import React from "react";
import { Link } from "react-router-dom";
import { Lock, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";

export default function LockedView({ what = "this profile" }) {
  const { user } = useAuth();
  const isUnverified = Boolean(user && !user.email_verified);

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-4 py-20 text-center">
      <Card className="w-full p-8">
        <div className="mx-auto inline-flex h-12 w-12 items-center justify-center rounded-full bg-teal-50">
          {isUnverified ? <MailCheck className="h-6 w-6 text-primary" /> : <Lock className="h-6 w-6 text-primary" />}
        </div>
        {isUnverified ? (
          <>
            <h1 className="mt-4 text-2xl font-[680] text-foreground">Please verify your email to view {what}</h1>
            <p className="mt-2 text-muted-foreground">
              We sent a 6-digit code to <span className="font-[560] text-foreground">{user?.email}</span>.
              Confirm it to unlock the rest of Startup Otter.
            </p>
            <div className="mt-6 flex justify-center gap-2">
              <Link to="/verify-email">
                <Button data-testid="locked-verify-button">Verify your email</Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <h1 className="mt-4 text-2xl font-[680] text-foreground">Create a free account to view {what}</h1>
            <p className="mt-2 text-muted-foreground">You can browse our directories freely, but viewing full profiles and resources requires a free Startup Otter account.</p>
            <div className="mt-6 flex justify-center gap-2">
              {user ? (
                <Link to="/dashboard"><Button>Go to dashboard</Button></Link>
              ) : (
                <>
                  <Link to="/register"><Button data-testid="locked-register-button">Create free account</Button></Link>
                  <Link to="/login"><Button variant="secondary">Log in</Button></Link>
                </>
              )}
            </div>
          </>
        )}
      </Card>
    </div>
  );
}
